import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const MARKER_LEGEND = [
  { color: '#f44336', label: 'Anomalia' },
  { color: '#4caf50', label: 'Finalizada' },
  { color: '#2196f3', label: 'Aguardando / inspeção' },
  { color: '#ff9800', label: 'Digitação' },
  { color: '#9e9e9e', label: 'GDIS / análise' },
];

const NsirMapaMapLegend = () => (
  <Paper
    elevation={3}
    sx={{
      position: 'absolute',
      bottom: 12,
      left: 12,
      zIndex: 1000,
      px: 1.5,
      py: 1,
      maxWidth: 280,
      bgcolor: (t) => (t.palette.mode === 'dark' ? 'rgba(17,25,39,0.92)' : 'rgba(255,255,255,0.92)'),
      backdropFilter: 'blur(6px)',
      pointerEvents: 'none',
    }}
  >
    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>
      Legenda
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
      {MARKER_LEGEND.map((item) => (
        <Box key={item.color} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: item.color, flexShrink: 0 }} />
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  </Paper>
);

export default NsirMapaMapLegend;
